const style = {
  simpleRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  simpleColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  spacedBetweenRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  manageFieldsEnabledItemsVisibilityLabels: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    paddingBottom: 5,
    borderBottom: '1px solid #b6b6b8',
  },
  enabledHeaderLabel: {
    fontSize: 10,
    fontWeight: 'bold',
    padding: 5,
    textAlign: 'center',
  },
  enabledHeaderRemove: {
    width: 53,
  },
  enabledHeaderSort: {
    width: '20%',
    marginLeft: 5,
  },
  enabledHeaderType: {
    width: '24%',
    marginLeft: 5,
  },
  enabledHeaderField: {
    width: '54%',
    marginLeft: 5,
    marginRight: 5,
  },
  enabledHeaderVisibility: {
    width: 45,
    marginLeft: 3,
  },

  manageFieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    padding: 10,
    height: 'calc(100vh - 400px)',
    margin: 5,
    border: '1px solid black',
    overflowY: 'scroll',
  },
  manageFieldsContainerSubContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: 'calc(100% - 10px)',
    padding: 10,
    margin: 5,
  },
  visibilityLabel: {
    alignSelf: 'flex-end',
    fontSize: 10,
    fontWeight: 'bold',
    marginLeft: 3,
    padding: 5,
    textAlign: 'center',
    verticalAlign: 'bottom',
    width: 45,
  },
};

export default style;
